export const ColorPrefixes = {
  ACCENT: 'accent',
  EMOTION: 'emotion',
} as const;
